import api from './api';
import ErrorService from './errorService';


export const regionService = {

    getAllRegion: async () => {
        try {
          const response = await ErrorService.withTimeout(api.get('/Regions'));
          return response.data;
      
        } catch (error) {
          ErrorService.handleApiError('Error al obtener las Regiones:', error);
          throw error;
        }
      },



};